var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.item.extra === 'main')?_c('h1',[_vm._v(_vm._s(_vm.item.value))]):_c('h2',[_vm._v(_vm._s(_vm.item.value))])])}
var staticRenderFns = []

export { render, staticRenderFns }